import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { formatApiErrorDetail } from "../auth/AuthContext";
import { AuthAside, AuthLegal } from "../components/AuthAside";
import "./Auth.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email, origin: window.location.origin });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-shell">
      <AuthAside />
      <main className="auth-main">
        <div className="auth-card" data-testid="forgot-card">
          <h1 className="auth-title">Reset password</h1>
          <p className="auth-lede">Enter your email and we'll send you a reset link.</p>

          {error && <div className="auth-error" data-testid="forgot-error">{error}</div>}

          {sent ? (
            <div className="auth-success" data-testid="forgot-success">
              If an account exists for <strong>{email}</strong>, a reset link is on its way. It expires in 1 hour.
            </div>
          ) : (
            <form onSubmit={submit} className="auth-form">
              <div className="auth-field">
                <label htmlFor="forgot-email-input">Email</label>
                <input id="forgot-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                  required autoComplete="email" data-testid="forgot-email" />
              </div>
              <button className="auth-btn" type="submit" disabled={loading} data-testid="forgot-submit">
                {loading ? "Sending…" : "Send reset link"}
              </button>
            </form>
          )}

          <p className="auth-foot">
            <Link to="/login" data-testid="back-to-login">Back to sign in</Link>
          </p>
        </div>

        <AuthLegal />
      </main>
    </div>
  );
}
